import { Box, Flex, Stack, Tooltip, Text } from '@mantine/core';
import { IconAlertOctagon } from '@tabler/icons';
import { capitalize } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import SyncContext from '../../../../context/SyncContext';
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext';
import { LIGHT_BLUE_BACKGROUND, LIGHT_GREY_BG, PRIMARY_BLUE } from '../../../../constants/colors';
import { DomainHeaderIcon, FlagIcon, ReleaseDateIcon } from '../../../../icons/x-symbol-svgrepo-com';
import OwnerHoverCard from './OwnerHoverCard';

interface StatusCellProps {
  record: any;
  accessor: string;
  statuses: any[]
  /* isMatchingStatus: boolean; */
}

export const StatusCell = ({ record, accessor, statuses }: StatusCellProps) => {

  const { requestPriorities } =
    useContext(SyncContext);

  const { openActivity, threeSixtyColumns } = useContext(SingleCustomerContext);
  const relevantColoumn = threeSixtyColumns?.find((coloumn: any)=> coloumn.label === accessor)
  const showReleaseDate = relevantColoumn?.deliveryDate === true
  const [color, setColor] = useState('');
  const [backgroundColor, setBackgroundColor] = useState(LIGHT_GREY_BG);
  const lowerCaseStatuses = statuses?.map((status: any) => status?.toLowerCase());
  const isMatchingStatus = lowerCaseStatuses?.includes(record?.status?.toLowerCase());
  const firstEvidence = record?.evidences[0]

  useEffect(() => {
    const firstEvidenceForPriority = record?.evidences[0]
    /* setPriority(item?.priority || "Unassigned"); */
    const currentPriorityIndex = requestPriorities?.findIndex(
      (r: any) => r?.key?.toLowerCase() === firstEvidenceForPriority?.priority?.toLowerCase()
    );
    /* if (currentPriorityIndex === -1) {
      setPriority("Unassigned");
    } */
    setColor(requestPriorities[currentPriorityIndex]?.color);
    if (requestPriorities[currentPriorityIndex]?.background) {
      setBackgroundColor(requestPriorities[currentPriorityIndex]?.background);
    }
  }, [record]);

  return (
    <>
      {isMatchingStatus ?
        (
          <Flex justify="center" align="center" py={4} /* pl={8} */>
            <Flex 
              bg={LIGHT_BLUE_BACKGROUND} 
              w={112}
              h={24}
              style={{
                borderRadius: 15,
              }}
              align="center"
              justify="space-around"
              pl={6.7}
            >
              {
                firstEvidence?.createdAt ?
                  <Tooltip label={<Flex>
                    <Text mr={4}>Requested date:</Text>
                    <Text>{
                      firstEvidence?.createdAt ?
                        moment(firstEvidence?.createdAt).format('MMM DD, YYYY') : 'Unassigned'
                    }
                    </Text>
                  </Flex>} withinPortal>
                    <Stack justify='center' style={{ marginTop: 1 }}>
                      <FlagIcon fill={PRIMARY_BLUE} />
                    </Stack>
                  </Tooltip>
                  : 
                  <Box w={14} h={10} />
              }
              {
                firstEvidence?.gtmCommittedDate ?
                  <Tooltip label={
                    <Flex>
                      <Text mr={4}>Commitment date:</Text>
                      <Text>{
                        firstEvidence?.gtmCommittedDate ? 
                          moment(firstEvidence?.gtmCommittedDate).format('MMM DD, YYYY') : 'Unassigned'
                      }
                      </Text>
                    </Flex>
               
                  } withinPortal>
                    <Stack justify='center'>
                      <DomainHeaderIcon fill={PRIMARY_BLUE} />
                    </Stack>
                  </Tooltip>
                  :
                  <Box w={14} h={10} />
              }
              {(firstEvidence?.deliveryDate && showReleaseDate) ?<Tooltip label={<Flex>
                <Text mr={4}>Release date:</Text>
                <Text>{
                  firstEvidence?.deliveryDate ? moment(firstEvidence?.deliveryDate).format('MMM DD, YYYY') : 'Unassigned'
                }
                </Text>
              </Flex>} withinPortal>
                <Stack justify='center'>
                  <ReleaseDateIcon fill={PRIMARY_BLUE} />
                </Stack>
              </Tooltip>: <Box w={15} h={10} />
              }



              <Tooltip label={
                <Flex>
                  <Text>{ capitalize(firstEvidence?.priority) || 'Unassigned'}</Text>
                </Flex>

               
              } withinPortal>
                <Stack justify='center'>
                  <IconAlertOctagon color={color} size={14}  fill={backgroundColor} />
                </Stack>
              </Tooltip>

              <OwnerHoverCard record={record} openActivity={openActivity} />
            </Flex>
          </Flex>
        ) : (
          <></>
        )}
    </>
  );
} 